var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "h-full" }, [
    _vm.data.post_type === "live" ||
    _vm.data.post_type === "video" ||
    _vm.data.post_type === "podcast"
      ? _c(
          "div",
          {
            staticClass: "dpd-card h-full bg-white card-video",
            class: [
              _vm.data.post_type,
              _vm.data.highlight,
              _vm.data.post_type === "live" &&
              _vm.data.card_data.status === "later"
                ? "later"
                : "",
              ((_vm.data.post_type === "live" &&
                _vm.data.card_data.status === "now") ||
                _vm.data.post_type === "video" ||
                  _vm.data.post_type === "podcast") &&
              !_vm.data.card_data.external_link
                ? "overlay-video"
                : "",
              _vm.data.card_data.external_link
                ? "dpd-card_open-external-link"
                : ""
            ],
            attrs: {
              "data-description": _vm.data.description,
              "data-platform": _vm.data.card_data.platform,
              "data-youtube": _vm.data.card_data.youtube_url,
              "data-video-id":
                (_vm.data.post_type === "live" &&
                  _vm.data.card_data.status === "now") ||
                _vm.data.post_type === "video" ||
                  _vm.data.post_type === "podcast"
                  ? _vm.data.card_data.youtube_url
                  : "",
              "data-livestream-src": _vm.data.card_data.livestream_src,
              "data-livestream-id": _vm.data.card_data.livestream_id,
              "data-spotify-src": _vm.data.card_data.spotify_src,
              "data-soundcloud-src": _vm.data.card_data.soundcloud_src,
              "data-external-link": _vm.data.card_data.external_link
            }
          },
          [
            _c("div", { staticClass: "dpd-card_card-content" }, [
              _c(
                "div",
                {
                  staticClass: "px-4 py-2 leading-none flex items-center",
                  class:
                    _vm.data.card_data.status === "now"
                      ? "text-red"
                      : "text-darkGrey"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-serif text-3xl",
                      class: [
                        _vm.data.card_data.status === "now" ? "" : "text-grey",
                        _vm.data.post_type === "live" ? "" : "hidden"
                      ]
                    },
                    [_vm._v("•")]
                  ),
                  _vm._v(" \n        "),
                  _c(
                    "span",
                    { class: _vm.data.post_type === "live" ? "" : "hidden" },
                    [_vm._v(_vm._s(_vm.data.card_data.time))]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dpd-card_thumbnail video" }, [
                _c("div", {
                  staticClass: "thumbnail-image",
                  style:
                    "background-image: url(" +
                    _vm.data.card_data.thumbnail +
                    ")"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "dpd-card_icon",
                  class: _vm.data.post_type
                })
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "p-5 pb-0 font-bold text-sm",
                domProps: { innerHTML: _vm._s(_vm.data.card_data.title) }
              })
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "dpd-card_fav",
              class: ["id-" + _vm.data.postid, { active: _vm.isFavourite() }],
              attrs: { "data-id": _vm.data.postid },
              on: {
                click: function($event) {
                  return _vm.setFav()
                }
              }
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.post_type === "images"
      ? _c(
          "div",
          {
            staticClass: "dpd-card h-full bg-white card-images",
            class: [
              _vm.data.card_data.external_link
                ? "dpd-card_open-external-link"
                : ""
            ],
            attrs: {
              "data-id": _vm.data.postid,
              "data-external-link": _vm.data.card_data.external_link
            }
          },
          [
            _c("div", { staticClass: "dpd-card_card-content" }, [
              _c("div", { staticClass: "dpd-card_thumbnail images" }, [
                _c("div", {
                  staticClass: "thumbnail-image",
                  style:
                    "background-image: url(" +
                    _vm.data.card_data.thumbnail +
                    ")"
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "dpd-card_icon",
                  class: _vm.data.post_type
                })
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "p-5 pb-0 font-bold text-sm",
                domProps: { innerHTML: _vm._s(_vm.data.card_data.title) }
              })
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "dpd-card_fav",
              class: ["id-" + _vm.data.postid, { active: _vm.isFavourite() }],
              attrs: { "data-id": _vm.data.postid },
              on: {
                click: function($event) {
                  return _vm.setFav()
                }
              }
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.post_type === "article" ||
    _vm.data.post_type === "interview" ||
    _vm.data.post_type === "others"
      ? _c(
          "a",
          {
            staticClass: "dpd-card h-full bg-white card-article",
            attrs: {
              href: _vm.data.card_data.link,
              target: _vm.data.card_data.open_in,
              "data-id": _vm.data.postid
            }
          },
          [
            _c("div", { staticClass: "dpd-card_card-content" }, [
              _c("div", { staticClass: "p-4" }, [
                _c("div", { staticClass: "dpd-card_thumbnail news" }, [
                  _c("div", {
                    staticClass: "thumbnail-image",
                    style:
                      "background-image: url(" +
                      _vm.data.card_data.thumbnail +
                      ")"
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dpd-card_icon news" })
                ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "p-5 pb-0 font-bold text-sm",
                  domProps: { innerHTML: _vm._s(_vm.data.card_data.title) }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "dpd-card_fav",
              class: ["id-" + _vm.data.postid, { active: _vm.isFavourite() }],
              attrs: { "data-id": _vm.data.postid },
              on: {
                click: function($event) {
                  return _vm.setFav()
                }
              }
            })
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.post_type === "welcome"
      ? _c(
          "div",
          {
            staticClass: "dpd-card pb-0 h-full bg-blue text-white card-welcome",
            attrs: { "data-id": _vm.data.postid }
          },
          [
            _c("div", { staticClass: "h-full dpd-card_card-content" }, [
              _c(
                "div",
                { staticClass: "h-full flex items-center justify-start p-8" },
                [
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "w-full leading-none text-30px mb-3" },
                      [_vm._v(_vm._s(_vm.data.card_data.sub_title))]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "w-full font-bold leading-none text-50px xxl:text-60px mb-4",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.card_data.main_title)
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "button bg-red hidden",
                        attrs: {
                          href: _vm.data.card_data.button_link,
                          target: "_self"
                        }
                      },
                      [_vm._v(_vm._s(_vm.data.card_data.button_text))]
                    )
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.post_type === "social"
      ? _c(
          "a",
          {
            staticClass: "dpd-card pb-0 h-full text-white card-social",
            class: _vm.data.card_data.card_color,
            attrs: {
              href: _vm.data.card_data.link,
              target: _vm.data.card_data.open_in,
              "data-id": _vm.data.postid
            }
          },
          [
            _c("div", { staticClass: "h-full dpd-card_card-content" }, [
              _c(
                "div",
                { staticClass: "h-full flex items-center justify-start p-8" },
                [
                  _c("div", [
                    _c("div", [
                      _c("img", {
                        staticClass: "dpd-card_social-icon mb-3",
                        attrs: { src: _vm.data.card_data.icon, alt: "" }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "w-full leading-none text-30px mb-3",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.card_data.sub_title)
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "w-full font-bold leading-none text-30px xxl:text-40px sm:mb-4",
                      domProps: {
                        innerHTML: _vm._s(_vm.data.card_data.main_title)
                      }
                    })
                  ])
                ]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.data.post_type === "banner"
      ? _c(
          "a",
          {
            staticClass: "dpd-card pb-0 h-full bg-white card-banner",
            attrs: {
              href: _vm.data.card_data.link,
              target: _vm.data.card_data.open_in,
              "data-id": _vm.data.postid
            }
          },
          [
            _c("div", { staticClass: "h-full flex items-center" }, [
              _c("img", {
                staticClass: "w-full h-auto dpd-card_banner-image",
                attrs: { src: _vm.data.card_data.image, alt: "" }
              })
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/reshmirav/devilbox/data/www/whd/whd/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/reshmirav/devilbox/data/www/whd/whd/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/Card.vue?vue&type=template&id=788441c4&
// module id = 66
// module chunks = 0